module.exports = __webpack_public_path__ + "static/media/ic_save.cfdec1ac.svg";